import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg viewBox="0 0 379 356" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#prefix__clip0_2979_4237)">
        <circle cx={180.5} cy={180.5} r={180.5} fill="#F1F6FE" />
        <g filter="url(#prefix__filter0_d_2979_4237)">
          <g clipPath="url(#prefix__clip1_2979_4237)">
            <rect
              x={-7}
              y={172}
              width={256}
              height={230}
              rx={20}
              transform="rotate(-30 -7 172)"
              fill="#fff"
            />
            <g clipPath="url(#prefix__clip2_2979_4237)">
              <path
                d="M-3 178.928A8 8 0 01-.072 168L207.774 48a8 8 0 0110.928 2.928l52 90.067L49 268.995l-52-90.067z"
                fill="#06265B"
              />
              <g filter="url(#prefix__filter1_d_2979_4237)">
                <path
                  d="M-3 178.928A8 8 0 01-.072 168L207.774 48a8 8 0 0110.928 2.928l52 90.067L49 268.995l-52-90.067z"
                  fill="#06265B"
                />
                <path
                  d="M-3 178.928A8 8 0 01-.072 168L207.774 48a8 8 0 0110.928 2.928l52 90.067L49 268.995l-52-90.067z"
                  fill="url(#prefix__paint0_radial_2979_4237)"
                />
                <path
                  d="M-3 178.928A8 8 0 01-.072 168L207.774 48a8 8 0 0110.928 2.928l52 90.067L49 268.995l-52-90.067z"
                  fill="url(#prefix__paint1_radial_2979_4237)"
                />
                <path
                  d="M-3 178.928A8 8 0 01-.072 168L207.774 48a8 8 0 0110.928 2.928l52 90.067L49 268.995l-52-90.067z"
                  fill="url(#prefix__paint2_radial_2979_4237)"
                  fillOpacity={0.7}
                />
              </g>
              <rect
                x={34.353}
                y={192.292}
                width={154}
                height={12}
                rx={6}
                transform="rotate(-30 34.353 192.292)"
                fill="#fff"
              />
              <rect
                x={46.049}
                y={213.253}
                width={188}
                height={12}
                rx={6}
                transform="rotate(-30 46.049 213.253)"
                fill="#fff"
              />
            </g>
            <rect
              x={77.785}
              y={270.852}
              width={10}
              height={10}
              rx={5}
              transform="rotate(-30 77.785 270.852)"
              fill="#E1E1E3"
            />
            <rect
              x={93.373}
              y={261.852}
              width={138}
              height={10}
              rx={5}
              transform="rotate(-30 93.373 261.852)"
              fill="#E1E1E3"
            />
            <path
              d="M98.285 306.358a7 7 0 012.562-9.562l168.009-97a7 7 0 019.562 2.562l15 25.981a7 7 0 01-2.562 9.562l-168.009 97a7 7 0 01-9.562-2.562l-15-25.981z"
              fill="#F1F6FE"
            />
            <path
              d="M162.273 292.509l1.806-1.043-3.727-2.115c.711-1.009.825-2.352.209-3.419a3.253 3.253 0 00-4.449-1.182l-3.395 1.96 4.9 8.487 1.673-.966-1.701-2.946 1.273-.735 3.411 1.959zm-6.98-5.201l1.722-.994c.63-.364 1.467-.119 1.873.584.406.704.206 1.562-.424 1.926l-1.722.994-1.449-2.51zm9.333.658l4.571-2.639a4.149 4.149 0 00-.31-.678c-1.029-1.782-3.121-2.465-4.916-1.429-1.903 1.099-2.395 3.242-1.352 5.048 1.043 1.807 3.133 2.459 5.17 1.283 1.164-.672 1.8-1.67 1.894-2.823h-1.681c-.064.506-.402 1.041-1.008 1.391-.825.476-1.687.521-2.368-.153zm-.724-1.199c-.266-.88.045-1.658.881-2.141.655-.378 1.513-.404 2.211.356l-3.092 1.785zm8.079-7.945l.971 5.097-3.917-3.396-1.722.994 5.804 4.732 1.782-1.029-1.196-7.392-1.722.994zm2.832-2.605c.533-.308.718-.997.417-1.518a1.133 1.133 0 00-1.53-.41c-.522.301-.699 1.002-.398 1.523.301.521.989.706 1.511.405zm3.144 7.237l1.564-.903-3.5-6.062-1.564.903 3.5 6.062zm1.885-6.875c-.189-.328.028-.679.416-.903a1.184 1.184 0 011.327.058l.914-1.498c-.956-.563-2.064-.522-3.046.045-1.249.721-1.905 2.021-1.191 3.258 1.232 2.134 4.08-.157 4.591.728.203.352-.038.717-.535 1.004-.606.35-1.187.297-1.643-.102l-.917 1.548c.975.682 2.166.673 3.379-.027 1.297-.749 2.073-2.038 1.317-3.347-1.288-2.231-4.094.133-4.612-.764zm6.499-1.15l4.571-2.639a4.149 4.149 0 00-.31-.678c-1.029-1.782-3.121-2.466-4.916-1.43-1.903 1.099-2.395 3.243-1.352 5.049 1.043 1.807 3.133 2.459 5.17 1.283 1.164-.672 1.8-1.67 1.894-2.823h-1.681c-.064.506-.402 1.041-1.008 1.391-.825.476-1.687.521-2.368-.153zm-.724-1.199c-.266-.881.045-1.658.881-2.141.655-.378 1.513-.405 2.211.356l-3.092 1.785zm11.693-8.028l-.868-1.503-1.37.791-.98-1.698-1.291 1.376.707 1.225-1.055.609.868 1.503 1.055-.609 1.456 2.522c.945 1.637 2.056 1.852 4.11.343l-.819-1.419c-.869.567-1.349.828-1.727.173l-1.456-2.522 1.37-.791zm3.508-4.256c-.813.469-1.268 1.136-1.317 1.892l-1.792-3.104-1.564.903 4.9 8.487 1.564-.903-1.89-3.273c-.609-1.055-.298-1.833.466-2.274.703-.406 1.445-.268 1.921.556l2.037 3.528 1.564-.903-2.149-3.722c-.931-1.612-2.455-1.929-3.74-1.187zm4.081-3.099c.533-.308.718-.997.417-1.518a1.132 1.132 0 00-1.53-.41c-.522.301-.699 1.001-.398 1.523.301.521.989.706 1.511.405zm3.144 7.237l1.564-.903-3.5-6.062-1.564.903 3.5 6.062zm1.885-6.875c-.189-.328.028-.68.416-.904a1.184 1.184 0 011.327.059l.913-1.498c-.955-.563-2.063-.522-3.045.045-1.249.721-1.905 2.021-1.191 3.258 1.232 2.134 4.08-.157 4.591.728.203.352-.038.717-.535 1.004-.607.35-1.187.297-1.643-.102l-.917 1.548c.975.682 2.166.673 3.379-.027 1.297-.749 2.073-2.038 1.317-3.347-1.288-2.231-4.094.133-4.612-.764zm8.667-5.004c-.189-.328.028-.679.416-.903a1.184 1.184 0 011.327.058l.913-1.498c-.955-.563-2.063-.522-3.045.045-1.249.721-1.905 2.021-1.191 3.258 1.232 2.134 4.08-.157 4.591.728.203.352-.038.717-.535 1.004-.606.35-1.187.297-1.643-.102l-.917 1.548c.975.682 2.166.673 3.379-.027 1.297-.749 2.073-2.038 1.317-3.347-1.288-2.231-4.094.133-4.612-.764zm12.229-1.274l-4.281-1.618.708-4.402-1.867 1.078-.545 3.872-2.94-5.093-1.564.903 4.9 8.487 1.564-.903-1.589-2.752 3.795 1.478 1.819-1.05zm-2.363-7.688a1.12 1.12 0 00.417-1.518 1.133 1.133 0 00-1.53-.41c-.522.301-.699 1.002-.398 1.523.301.522.989.706 1.511.405zm3.144 7.238l1.564-.903-3.5-6.062-1.564.903 3.5 6.062zm2.995-1.73l1.564-.903-5.11-8.851-1.564.903 5.11 8.851zm2.996-1.729l1.564-.903-5.11-8.851-1.564.903 5.11 8.851z"
              fill="#06265B"
            />
          </g>
        </g>
        <g filter="url(#prefix__filter2_d_2979_4237)">
          <g clipPath="url(#prefix__clip3_2979_4237)">
            <rect
              x={39.945}
              y={149}
              width={256}
              height={230}
              rx={20}
              transform="rotate(-15 39.945 149)"
              fill="#fff"
            />
            <g clipPath="url(#prefix__clip4_2979_4237)" opacity={0.7}>
              <path
                d="M42.016 156.727a8 8 0 015.657-9.798l231.822-62.116a8 8 0 019.798 5.657l26.917 100.456-247.277 66.258-26.917-100.457z"
                fill="#0061FF"
              />
              <g filter="url(#prefix__filter3_d_2979_4237)">
                <path
                  d="M42.016 156.727a8 8 0 015.657-9.798l231.822-62.116a8 8 0 019.798 5.657l26.917 100.456-247.277 66.258-26.917-100.457z"
                  fill="#0061FF"
                />
                <path
                  d="M42.016 156.727a8 8 0 015.657-9.798l231.822-62.116a8 8 0 019.798 5.657l26.917 100.456-247.277 66.258-26.917-100.457z"
                  fill="url(#prefix__paint3_radial_2979_4237)"
                />
                <path
                  d="M42.016 156.727a8 8 0 015.657-9.798l231.822-62.116a8 8 0 019.798 5.657l26.917 100.456-247.277 66.258-26.917-100.457z"
                  fill="url(#prefix__paint4_radial_2979_4237)"
                />
                <path
                  d="M42.016 156.727a8 8 0 015.657-9.798l231.822-62.116a8 8 0 019.798 5.657l26.917 100.456-247.277 66.258-26.917-100.457z"
                  fill="url(#prefix__paint5_radial_2979_4237)"
                  fillOpacity={0.7}
                />
              </g>
              <rect
                x={75.887}
                y={176.909}
                width={154}
                height={12}
                rx={6}
                transform="rotate(-15 75.887 176.909)"
                fill="#fff"
              />
              <rect
                x={81.758}
                y={200.183}
                width={188}
                height={12}
                rx={6}
                transform="rotate(-15 81.758 200.183)"
                fill="#fff"
              />
            </g>
            <rect
              x={96.256}
              y={266.427}
              width={10}
              height={10}
              rx={5}
              transform="rotate(-15 96.256 266.427)"
              fill="#E1E1E3"
            />
            <rect
              x={113.643}
              y={261.768}
              width={138}
              height={10}
              rx={5}
              transform="rotate(-15 113.643 261.768)"
              fill="#E1E1E3"
            />
            <path
              d="M106.866 306.03a7 7 0 014.95-8.573l187.39-50.211a7 7 0 018.573 4.95l7.765 28.977a7.001 7.001 0 01-4.95 8.574l-187.39 50.211a7 7 0 01-8.573-4.95l-7.765-28.978z"
              fill="#F1F6FE"
            />
            <path
              d="M172.257 309.215l2.015-.54-3.053-3.009c.948-.79 1.406-2.058 1.087-3.248a3.254 3.254 0 00-3.992-2.293l-3.786 1.015 2.536 9.466 1.866-.5-.88-3.286 1.42-.381 2.787 2.776zm-5.396-6.831l1.921-.514c.703-.189 1.447.264 1.657 1.048.211.785-.204 1.563-.907 1.751l-1.921.515-.75-2.8zm8.845 3.051l5.099-1.366a4.157 4.157 0 00-.125-.735c-.532-1.988-2.376-3.19-4.378-2.653-2.123.569-3.153 2.511-2.613 4.526.54 2.015 2.39 3.186 4.662 2.578 1.298-.348 2.171-1.147 2.56-2.237l-1.624-.435c-.192.472-.657.901-1.333 1.082-.92.247-1.765.067-2.248-.76zm-.389-1.345c-.029-.92.473-1.591 1.406-1.841.73-.195 1.565.001 2.042.917l-3.448.924zm9.86-5.584l-.382 5.175-2.904-4.295-1.92.515 4.381 6.073 1.988-.533.757-7.45-1.92.515zm3.41-1.784a1.12 1.12 0 00.795-1.358 1.134 1.134 0 00-1.372-.792c-.581.156-.934.787-.778 1.368.156.582.773.938 1.355.782zm1.163 7.805l1.745-.467-1.812-6.762-1.745.468 1.812 6.761zm3.601-6.153c-.098-.365.203-.649.635-.765.501-.134.948.022 1.267.4l1.27-1.21c-.777-.792-1.858-1.039-2.953-.745-1.393.373-2.363 1.459-1.994 2.839.638 2.38 3.982.904 4.247 1.891.105.392-.223.683-.778.832-.676.181-1.223-.021-1.56-.524l-1.287 1.257c.766.911 1.919 1.211 3.271.849 1.447-.388 2.53-1.432 2.139-2.892-.667-2.489-3.989-.932-4.257-1.932zm6.575.571l5.098-1.366a4.152 4.152 0 00-.124-.735c-.533-1.987-2.377-3.189-4.378-2.653-2.123.569-3.153 2.512-2.613 4.527s2.39 3.186 4.662 2.577c1.298-.348 2.171-1.147 2.56-2.237l-1.624-.434c-.192.471-.657.9-1.333 1.082-.92.246-1.765.067-2.248-.761zm-.389-1.345c-.029-.92.472-1.59 1.405-1.84.731-.196 1.566.001 2.043.916l-3.448.924zm13.373-4.728l-.45-1.677-1.528.41-.507-1.894-1.603.995.366 1.366-1.177.315.45 1.677 1.176-.315.754 2.813c.489 1.825 1.506 2.321 3.881 1.395l-.424-1.583c-.986.323-1.517.45-1.713-.28l-.754-2.813 1.529-.409zm4.489-3.203c-.906.243-1.519.769-1.761 1.486l-.928-3.461-1.744.467 2.536 9.466 1.744-.467-.978-3.652c-.315-1.176.186-1.847 1.038-2.075.785-.21 1.466.115 1.712 1.034l1.055 3.935 1.744-.467-1.112-4.152c-.482-1.798-1.873-2.498-3.306-2.114zm4.744-1.938c.595-.159.951-.777.796-1.358a1.132 1.132 0 00-1.372-.792c-.582.156-.934.786-.779 1.368.156.581.774.938 1.355.782zm1.164 7.805l1.744-.468-1.812-6.761-1.744.467 1.812 6.762zm3.6-6.154c-.098-.365.203-.648.636-.764.5-.134.948.021 1.266.399l1.271-1.209c-.778-.792-1.859-1.039-2.954-.745-1.393.373-2.363 1.459-1.993 2.838.638 2.38 3.982.904 4.246 1.892.105.392-.223.683-.777.831-.676.181-1.223-.02-1.561-.524l-1.286 1.258c.766.911 1.918 1.211 3.271.848 1.447-.387 2.529-1.431 2.138-2.892-.667-2.488-3.989-.931-4.257-1.932zm9.667-2.59c-.098-.365.203-.649.636-.765.5-.134.947.022 1.266.4l1.27-1.21c-.777-.791-1.858-1.038-2.953-.745-1.393.374-2.363 1.46-1.993 2.839.637 2.38 3.981.904 4.246 1.891.105.393-.223.683-.777.832-.677.181-1.223-.02-1.561-.524l-1.286 1.258c.765.911 1.918 1.21 3.271.848 1.447-.388 2.529-1.431 2.138-2.892-.667-2.488-3.989-.931-4.257-1.932zm12.142 1.935L245 286.056l1.823-4.068-2.082.558-1.529 3.598-1.522-5.68-1.745.468 2.537 9.466 1.744-.468-.822-3.069 3.283 2.41 2.029-.544zm-.293-8.038a1.12 1.12 0 00.796-1.358 1.134 1.134 0 00-1.372-.792c-.582.156-.934.787-.779 1.368.156.582.774.938 1.355.782zm1.164 7.805l1.744-.467-1.812-6.762-1.744.468 1.812 6.761zm3.341-.895l1.744-.468-2.645-9.871-1.744.467 2.645 9.872zm3.341-.895l1.744-.468-2.645-9.872-1.744.468 2.645 9.872z"
              fill="#06265B"
            />
          </g>
        </g>
        <g filter="url(#prefix__filter4_d_2979_4237)">
          <g clipPath="url(#prefix__clip5_2979_4237)">
            <rect x={97.352} y={141} width={256} height={230} rx={20} fill="#fff" />
            <g clipPath="url(#prefix__clip6_2979_4237)">
              <path d="M97.352 149a8 8 0 018-8h240a8 8 0 018 8v104h-256V149z" fill="#0061FF" />
              <g filter="url(#prefix__filter5_d_2979_4237)">
                <path d="M97.352 149a8 8 0 018-8h240a8 8 0 018 8v104h-256V149z" fill="#0061FF" />
                <path
                  d="M97.352 149a8 8 0 018-8h240a8 8 0 018 8v104h-256V149z"
                  fill="url(#prefix__paint6_radial_2979_4237)"
                />
                <path
                  d="M97.352 149a8 8 0 018-8h240a8 8 0 018 8v104h-256V149z"
                  fill="url(#prefix__paint7_radial_2979_4237)"
                />
                <path
                  d="M97.352 149a8 8 0 018-8h240a8 8 0 018 8v104h-256V149z"
                  fill="url(#prefix__paint8_radial_2979_4237)"
                  fillOpacity={0.7}
                />
              </g>
              <rect x={121.352} y={179} width={154} height={12} rx={6} fill="#fff" />
              <rect x={121} y={203} width={188} height={12} rx={6} fill="#fff" />
            </g>
            <rect x={121.352} y={269} width={10} height={10} rx={5} fill="#E1E1E3" />
            <rect x={139.352} y={269} width={138} height={10} rx={5} fill="#E1E1E3" />
            <rect x={121.352} y={303} width={208} height={44} rx={7} fill="#F1F6FE" />
            <rect opacity={0.4} x={164.852} y={321} width={121} height={8} rx={4} fill="#0061FF" />
          </g>
        </g>
      </g>
      <circle cx={350} cy={135} r={29} fill="#FFE5E6" />
      <rect
        x={340.055}
        y={121.671}
        width={33.006}
        height={6.189}
        rx={3.094}
        transform="rotate(45 340.055 121.671)"
        fill="#FF4040"
      />
      <rect
        width={33.006}
        height={6.189}
        rx={3.094}
        transform="scale(-1 1) rotate(45 -326.378 -372.535)"
        fill="#FF4040"
      />
      <circle cx={51} cy={63.157} r={34} fill="#D6F5E1" />
      <path
        d="M34.3 59.863a3.628 3.628 0 015.131 0L49.65 70.08a3.628 3.628 0 01-5.13 5.13L34.3 64.993a3.628 3.628 0 010-5.13z"
        fill="#38CC6C"
      />
      <path
        d="M67.582 52.123a3.628 3.628 0 00-5.13 0L44.6 69.975a3.628 3.628 0 105.131 5.13l17.851-17.851a3.628 3.628 0 000-5.13z"
        fill="#38CC6C"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(121.035 64.028 138.468) scale(114.789 96.5184)"
        >
          <stop stopColor="#3374DB" />
          <stop offset={1} stopColor="#3374DB" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint1_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-250.55359 148.92166 -59.25342 -99.69105 204.19 60.254)"
        >
          <stop stopColor="#0E5BD7" />
          <stop offset={1} stopColor="#0E5BD8" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint2_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-13.068 1096.27 -34.905) scale(166.221 92.7204)"
        >
          <stop stopColor="#1F427A" />
          <stop offset={1} stopColor="#003A99" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint3_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-82.621 79.68868 -67.00489 -69.47047 259.444 190.209)"
        >
          <stop stopColor="#3374DB" />
          <stop offset={1} stopColor="#3374DB" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint4_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(164.274 129.821 66.703) scale(291.47 115.971)"
        >
          <stop stopColor="#0E5BD7" />
          <stop offset={1} stopColor="#0E5BD8" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint5_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(1.932 -6865.833 1964.98) scale(166.221 92.7204)"
        >
          <stop stopColor="#1F427A" />
          <stop offset={1} stopColor="#003A99" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint6_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(151.035 118.666 157.384) scale(114.789 96.5184)"
        >
          <stop stopColor="#3374DB" />
          <stop offset={1} stopColor="#3374DB" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint7_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-291.4466 3.69314 -1.46944 -115.96169 336.121 149.821)"
        >
          <stop stopColor="#0E5BD7" />
          <stop offset={1} stopColor="#0E5BD8" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="prefix__paint8_radial_2979_4237"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(16.932 -715.751 440.803) scale(166.221 92.7204)"
        >
          <stop stopColor="#1F427A" />
          <stop offset={1} stopColor="#003A99" stopOpacity={0} />
        </radialGradient>
        <clipPath id="prefix__clip0_2979_4237">
          <rect width={361} height={356} rx={178} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip1_2979_4237">
          <rect
            x={-7}
            y={172}
            width={256}
            height={230}
            rx={20}
            transform="rotate(-30 -7 172)"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="prefix__clip2_2979_4237">
          <path
            d="M-3 178.928A8 8 0 01-.072 168L207.774 48a8 8 0 0110.928 2.928l52 90.067L49 268.995l-52-90.067z"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="prefix__clip3_2979_4237">
          <rect
            x={39.945}
            y={149}
            width={256}
            height={230}
            rx={20}
            transform="rotate(-15 39.945 149)"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="prefix__clip4_2979_4237">
          <path
            d="M42.016 156.727a8 8 0 015.657-9.798l231.822-62.116a8 8 0 019.798 5.657l26.917 100.456-247.277 66.258-26.917-100.457z"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="prefix__clip5_2979_4237">
          <rect x={97.352} y={141} width={256} height={230} rx={20} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip6_2979_4237">
          <path d="M97.352 149a8 8 0 018-8h240a8 8 0 018 8v104h-256V149z" fill="#fff" />
        </clipPath>
        <filter
          id="prefix__filter0_d_2979_4237"
          x={-23}
          y={32}
          width={368.703}
          height={359.186}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2979_4237" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2979_4237" result="shape" />
        </filter>
        <filter
          id="prefix__filter1_d_2979_4237"
          x={-47}
          y={8}
          width={357.703}
          height={304.995}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={20} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2979_4237" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2979_4237" result="shape" />
        </filter>
        <filter
          id="prefix__filter2_d_2979_4237"
          x={23.945}
          y={70.742}
          width={338.805}
          height={320.421}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2979_4237" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2979_4237" result="shape" />
        </filter>
        <filter
          id="prefix__filter3_d_2979_4237"
          x={-0.055}
          y={46.742}
          width={356.266}
          height={254.441}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={20} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2979_4237" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2979_4237" result="shape" />
        </filter>
        <filter
          id="prefix__filter4_d_2979_4237"
          x={81.352}
          y={129}
          width={288}
          height={262}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={8} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2979_4237" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2979_4237" result="shape" />
        </filter>
        <filter
          id="prefix__filter5_d_2979_4237"
          x={57.352}
          y={105}
          width={336}
          height={192}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={20} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2979_4237" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2979_4237" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default SvgComponent;
